import React, {useState, useEffect, useCallback} from 'react';
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { iconHeight, iconLength, iconLink, iconThickness } from "../../../../../assetsSQFT";
import sqftConfig from "../../../../canvas/store/sqftConfig";
import { is3DMode } from "../../../NavigationHelper";

const MIN_INPUT_VALUE = 1;
const MIN_LOGICAL_VALUE = 6;
const MAX_VALUE = sqftConfig.measureUnit === "Metric" ? 15000 : 700;

const CustomSizeList = (props) => {
  const {isEnabled, shape, listKey} = props;

  const getSafeValue = useCallback((getter) => {
    if (!shape || typeof shape[getter] !== 'function') {
      return MIN_LOGICAL_VALUE.toString();
    }
    const value = shape[getter]();
    return (value !== undefined && value !== null) ? value.toString() : MIN_LOGICAL_VALUE.toString();
  }, [shape]);

  const [heightInput, setHeightInput] = useState(() => getSafeValue('getHeight'));
  const [widthInput,  setWidthInput]  = useState(() => getSafeValue('getWidth'));
  const [depthInput,  setDepthInput]  = useState(() => getSafeValue('getDepth'));

  useEffect(() => {
    setHeightInput(getSafeValue('getHeight'));
    setWidthInput(getSafeValue('getWidth'));
    setDepthInput(getSafeValue('getDepth'));
  }, [shape, listKey, getSafeValue]);

  const fixValue = (valStr) => {
    const val = parseFloat(valStr);
    if (isNaN(val)) return MIN_LOGICAL_VALUE;
    if (val < MIN_LOGICAL_VALUE) return MIN_LOGICAL_VALUE;
    if (val > MAX_VALUE) return MAX_VALUE;
    return val;
  };

  const onBlurHeight = () => {
    if (!shape || typeof shape.setHeight !== 'function') return;
    const fixed = fixValue(heightInput);
    shape.setHeight(fixed);
    setHeightInput(fixed.toString());
  };

  const onBlurWidth = () => {
    if (!shape || typeof shape.setWidth !== 'function') return;
    const fixed = fixValue(widthInput);
    shape.setWidth(fixed);
    setWidthInput(fixed.toString());
  };

  const onBlurDepth = () => {
    if (!shape || typeof shape.setDepth !== 'function') return;
    const fixed = fixValue(depthInput);
    shape.setDepth(fixed);
    setDepthInput(fixed.toString());
  };

  if (!shape) {
    return null;
  }

  return (
    <div className={isEnabled ? "" : " segment-container--disabled"}>
      <ul className="mitered-segment segment-params">
        {/* HEIGHT */}
        <li className="mitered-segment__content segment-height">
          <div className="segment-image">
            <img src={iconHeight} alt="Height"/>
          </div>
          <div className="segment-value">
            <input
              className="ui-input segment-value-input"
              type="number"
              min={MIN_INPUT_VALUE}
              max={MAX_VALUE}
              value={heightInput}
              onFocus={e => e.target.select()}
              onChange={e => setHeightInput(e.target.value)}
              onBlur={onBlurHeight}
            />
          </div>
          <div className="segment-description">
            <div><img src={iconLink} alt=""/></div>
            <div><FormattedMessage id="sqft.navigation.mitered.height"/></div>
          </div>
        </li>

        {/* WIDTH */}
        <li className="mitered-segment__content segment-length">
          <div className="segment-image">
            <img src={iconLength} alt="Width"/>
          </div>
          <div className="segment-value">
            <input
              className="ui-input segment-value-input"
              type="number"
              min={MIN_INPUT_VALUE}
              max={MAX_VALUE}
              value={widthInput}
              disabled={is3DMode()}
              onFocus={e => e.target.select()}
              onChange={e => setWidthInput(e.target.value)}
              onBlur={onBlurWidth}
            />
          </div>
          <div className="segment-description">
            <FormattedMessage id="sqft.manual.column.width"/>
          </div>
        </li>

        {/* DEPTH */}
        <li className="mitered-segment__content segment-thickness">
          <div className="segment-image">
            <img src={iconThickness} alt="Depth"/>
          </div>
          <div className="segment-value">
            <input
              className="ui-input segment-value-input"
              type="number"
              min={MIN_INPUT_VALUE}
              max={MAX_VALUE}
              value={depthInput}
              onFocus={e => e.target.select()}
              onChange={e => setDepthInput(e.target.value)}
              onBlur={onBlurDepth}
            />
          </div>
          <div className="segment-description">
            <FormattedMessage id="sqft.navigation.waterfall.depth"/>
          </div>
        </li>
      </ul>
    </div>
  );
};

CustomSizeList.propTypes = {
  isEnabled: PropTypes.bool,
  shape: PropTypes.object.isRequired,
  listKey: PropTypes.number,
};

const mapStateToProps = (store) => {
  return {
    menuOpened: store.sqftMenuState.menuOpened,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CustomSizeList);
